import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {
  COMPANY_ASF,
  COMMISSION_STATEMENT_GENERATION_CRITERIA_TYPE,
  COMPANY_ASF_PREMIUM,
  COMPANY_MULTISFERA,
  CONTRACT_OWNER_OFWCA,
  CONTRACT_OWNER_PARTNER,
  CONTRACT_STATUS_ACTIVE,
  CONTRACT_STATUS_CANCELED,
  CONTRACT_STATUS_CLOSED,
  CONTRACT_STATUS_DURING_TERMINATION,
  CONTRACT_STATUS_NEW,
  CONTRACT_STATUS_SENT_WITH_AUTENTI,
  CONTRACT_STATUS_TERMINATED,
  CONTRACT_STATUS_TO_TERMINATE,
  CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
  CONTRACT_TYPE_DURING_REGISTRATION,
  CONTRACT_TYPE_FOR_DEREGISTRATION,
  CONTRACT_TYPE_FRANCHISE,
  CONTRACT_TYPE_FRANCHISE_AGREEMENT,
  CONTRACT_TYPE_LEAD, CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE, CONTRACT_TYPE_LEAD_ONLY_HEALTH,
  CONTRACT_TYPE_LEASING,
  CONTRACT_TYPE_MANDATE,
  CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
  CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_MANDATE_STUDENT,
  CONTRACT_TYPE_OCK,
  CONTRACT_TYPE_PARTNERSHIP,
  CONTRACT_TYPE_PROFIT,
  CONTRACT_TYPE_SELF_BILLING,
  CONTRACT_TYPE_TERMINAL,
  DICT_TYPE_COMPANY,
  DICT_TYPE_CONTRACT_OWNER,
  DICT_TYPE_CONTRACT_TYPE,
  DICT_TYPE_FORM_OF_BUSINESS,
  DictService,
  FORM_OF_BUSINESS_NONE_PROPRIETORSHIP,
} from '../../../shared/services/dict.service';
import {delay, first, map, startWith, takeUntil, tap} from 'rxjs/operators';
import {Dictionary} from '../../../shared/interface/dictionary';
import {combineLatest, ReplaySubject} from 'rxjs';
import {Router} from '@angular/router';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ContractService} from '../../../shared/services/contract.service';
import {Partner} from '../../../shared/interface/partner';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ContractAddDialogComponent} from '../contract-add-dialog/contract-add-dialog.component';
import {Ofwca} from '../../../shared/interface/ofwca';
import {PartnerService} from '../../../shared/services/partner.service';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {Contract} from '../../../shared/interface/contract';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {
  ContractInsuranceCompaniesAddDialogComponent
} from '../contract-insurance-companies-add-dialog/contract-insurance-companies-add-dialog.component';
import moment from 'moment';
import {addBusinessDays} from '../../../shared/services/utils.service';
import {AuthService} from '../../../shared/services/auth.service';
import {validPhoneNumber} from '../../../shared/validator/phone-validator';
import {validIban} from '../../../shared/validator/iban-validator';
import {EmailAddress} from '../../../shared/interface/email-address';
import {PhoneNumber} from '../../../shared/interface/phone-number';
import {VatTaxpayers} from "../../../shared/interface/vat-taxpayers";
import {SelfBillingForm} from "../../../shared/interface/SelfBillingForm";
import {CommissionTableListItem} from "../../../shared/interface/commission-table";
import {CommissionTableService} from "../../../shared/services/commission-table.service";

@Component({
  selector: 'app-contract-add',
  templateUrl: './contract-add.component.html',
  styleUrls: ['./contract-add.component.scss']
})
export class ContractAddComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() partnerObject?: Partner = null;
  @Input() ofwcaObject?: Ofwca = null;
  @Input() selfBillingFormObject?: SelfBillingForm = null;
  @Input() dialogRef?: MatDialogRef<ContractAddDialogComponent> = null;
  @Output() contractCreated = new EventEmitter<string>();

  readonly CONTRACT_TYPE_SELF_BILLING = CONTRACT_TYPE_SELF_BILLING;
  readonly CONTRACT_TYPE_PROFIT = CONTRACT_TYPE_PROFIT;
  readonly CONTRACT_TYPE_PARTNERSHIP = CONTRACT_TYPE_PARTNERSHIP;
  readonly CONTRACT_TYPE_MANDATE = CONTRACT_TYPE_MANDATE;
  readonly CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE = CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE;
  readonly CONTRACT_TYPE_MANDATE_ONLY_HEALTH = CONTRACT_TYPE_MANDATE_ONLY_HEALTH;
  readonly CONTRACT_OWNER_PARTNER = CONTRACT_OWNER_PARTNER;
  readonly CONTRACT_TYPE_DURING_REGISTRATION = CONTRACT_TYPE_DURING_REGISTRATION;
  readonly CONTRACT_TYPE_FOR_DEREGISTRATION = CONTRACT_TYPE_FOR_DEREGISTRATION;
  readonly COMPANY_MULTISFERA = COMPANY_MULTISFERA;
  readonly CONTRACT_TYPE_LEAD_ONLY_HEALTH = CONTRACT_TYPE_LEAD_ONLY_HEALTH;
  readonly CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE = CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE;
  readonly CONTRACT_TYPE_MANDATE_STUDENT = CONTRACT_TYPE_MANDATE_STUDENT;

  readonly PARTNER_TYPES = [
    CONTRACT_TYPE_PARTNERSHIP,
    CONTRACT_TYPE_PROFIT,
    CONTRACT_TYPE_TERMINAL,
    CONTRACT_TYPE_FRANCHISE,
    CONTRACT_TYPE_OCK,
    CONTRACT_TYPE_LEASING,
    CONTRACT_TYPE_LEAD,
    CONTRACT_TYPE_SELF_BILLING,
    CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
    CONTRACT_TYPE_FRANCHISE_AGREEMENT,
    // CONTRACT_TYPE_MANDATE,
    // CONTRACT_TYPE_DURING_REGISTRATION,
    // CONTRACT_TYPE_FOR_DEREGISTRATION,
    CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE,
    CONTRACT_TYPE_LEAD_ONLY_HEALTH,
  ];
  readonly TYPES_ALL = [
    CONTRACT_TYPE_PARTNERSHIP,
    CONTRACT_TYPE_PROFIT,
    CONTRACT_TYPE_TERMINAL,
    CONTRACT_TYPE_FRANCHISE,
    CONTRACT_TYPE_OCK,
    CONTRACT_TYPE_LEASING,
    CONTRACT_TYPE_LEAD,
    CONTRACT_TYPE_SELF_BILLING,
    CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
    CONTRACT_TYPE_FRANCHISE_AGREEMENT,
    CONTRACT_TYPE_MANDATE,
    CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
    CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
    CONTRACT_TYPE_DURING_REGISTRATION,
    CONTRACT_TYPE_FOR_DEREGISTRATION,
    CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE,
    CONTRACT_TYPE_LEAD_ONLY_HEALTH,
    CONTRACT_TYPE_MANDATE_STUDENT
  ];
  readonly OFWCA_TYPES = [
    CONTRACT_TYPE_MANDATE,
    CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
    CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
    CONTRACT_TYPE_DURING_REGISTRATION,
    CONTRACT_TYPE_FOR_DEREGISTRATION,
    CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE,
    CONTRACT_TYPE_LEAD_ONLY_HEALTH,
    CONTRACT_TYPE_LEAD,
    CONTRACT_TYPE_MANDATE_STUDENT
  ];
  readonly PARTNERSHIP_TYPES = [
    CONTRACT_TYPE_PARTNERSHIP,
    CONTRACT_TYPE_PROFIT,
    CONTRACT_TYPE_MANDATE,
    CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
    CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
    CONTRACT_TYPE_DURING_REGISTRATION,
    CONTRACT_TYPE_FOR_DEREGISTRATION,
    CONTRACT_TYPE_MANDATE_STUDENT
  ];
  readonly PARTNERSHIP_ANNEX_TYPES = [
    CONTRACT_TYPE_PARTNERSHIP,
    CONTRACT_TYPE_PROFIT,
    CONTRACT_TYPE_MANDATE,
    CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
    CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
    CONTRACT_TYPE_MANDATE_STUDENT
  ];

  processingRequest = false;
  enableSaveButton = false;
  requiredOfwca = false;
  requiredPartner = true;
  requiredParentContract = false;
  requiredParentContractActive = false;
  showPartnershipContractSelect = false;
  contracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  contractsActive: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  contractForm: FormGroup;
  typeControl: FormControl;
  concludeDateControl: FormControl;
  companyControl: FormControl;
  ownerControl: FormControl;
  ofwcaControl: FormControl;
  partnerControl: FormControl;
  parentContractControl: FormControl;
  facilityControl: FormControl;
  numberGenerateControl: FormControl;
  selfBillingEmailControl: FormControl;
  selfBillingPhoneControl: FormControl;
  selfBillingAccountNumberControl: FormControl;
  selfBillingVatPayerControl: FormControl;
  selfBillingActiveVatPayerControl: FormControl;
  selfBillingCheckoutMethodControl: FormControl;
  assignedPartnerControl: FormControl;
  assignedContractControl: FormControl;
  selfBillingFormControl: FormControl;
  customRatesForm: FormControl;
  customTermsForm: FormControl;
  commissionTableControl: FormControl;
  commissionTables: CommissionTableListItem[] = [];
  commissionTableRequired = false;
  contractType?: Dictionary;
  formErrors = {};
  todayDate: string;
  maxDate: string;
  partnerNip: string;
  vatTaxpayersAccountNumber = [];
  limitDates = false;
  selfBillingContractType = false;
  partnershipContractType = false;
  customTermsContractType = false;
  nonePartnershipContractType = false;
  nonePartnershipTypeId = null;
  availableContracts = [];
  required = false;
  // getListOfVatButton = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private dictService: DictService,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private contractService: ContractService,
    private partnerService: PartnerService,
    private ofwcaService: OfwcaService,
    private dialog: MatDialog,
    private authService: AuthService,
    private commissionTableService: CommissionTableService
  ) {
    this.assignedContractControl = fb.control(false, []);
    this.contractForm = fb.group({
      type: this.typeControl = fb.control('', [Validators.required]),
      concludeDate: this.concludeDateControl = fb.control('', [Validators.required]),
      company: this.companyControl = fb.control('', [Validators.required]),
      commissionTable: this.commissionTableControl = fb.control( '', null),
      number: fb.control(''),
      owner: this.ownerControl = fb.control('', [Validators.required]),
      ofwca: this.ofwcaControl = fb.control(''),
      partner: this.partnerControl = fb.control(''),
      numberGenerate: this.numberGenerateControl = fb.control(true),
      parentContract: this.parentContractControl = fb.control(''),
      facility: this.facilityControl = fb.control(''),
      verified: fb.control(true),
      note: fb.control(''),
      selfBillingEmail: this.selfBillingEmailControl = fb.control('', [Validators.required, Validators.email]),
      selfBillingPhone: this.selfBillingPhoneControl = fb.control('', [Validators.required, validPhoneNumber()]),
      selfBillingAccountNumber: this.selfBillingAccountNumberControl = fb.control('', [Validators.required, validIban()]),
      selfBillingVatPayer: this.selfBillingVatPayerControl = fb.control(false),
      selfBillingActiveVatPayer: this.selfBillingActiveVatPayerControl = fb.control(false),
      selfBillingCheckoutMethod: this.selfBillingCheckoutMethodControl = fb.control(false),
      selfBillingForm: this.selfBillingFormControl = fb.control(''),
      customRates: this.customRatesForm = fb.control(false),
      customTerms: this.customTermsForm = fb.control(false),
      assignedPartner: this.assignedPartnerControl = fb.control(''),
    });

    // this.typeControl.disable();
    this.todayDate = moment().format('YYYY-MM-DD');
    this.maxDate = addBusinessDays(new Date(), 3).format('YYYY-MM-DD');
  }

  ngOnInit(): void {
    this.commissionTableService
      .getOptions()
      .pipe(
        first()
      )
      .subscribe(
        (commissionTables: CommissionTableListItem[]) => {

          this.commissionTables = commissionTables.sort(
            (
              a: CommissionTableListItem,
              b: CommissionTableListItem
            ) =>
              (b.validFrom || '')
                .localeCompare(a.validFrom || '')
          );

          // this.setDefaultCommissionTable();
        }
      );
    this.contractForm.valueChanges
      .pipe(
        delay(0),
        tap(() => this.enableSaveButton = this.contractForm.valid),
        takeUntil(this.destroyed$)
      )
      .subscribe();

    this.ownerControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(val => {
        // this.dictService.getKey(val)
        //   .subscribe((key: string) => {
        //     this.typeControl.enable();
        //     if (key === CONTRACT_OWNER_OFWCA) {
        //       this.requireOfwca();
        //     } else {
              this.requirePartner();
          //   }
          // });
      });
    this.partnerControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(val => {
        if (this.partnerObject.formOfBusiness.key === FORM_OF_BUSINESS_NONE_PROPRIETORSHIP) {
          this.requiredOfwca = true;
          this.requiredPartner = false;
          this.nonePartnershipContractType = true;
        } else {
          this.requiredOfwca = false;
          this.requiredPartner = true;
          this.nonePartnershipContractType = false;
        }
    });


    this.assignedContractControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(val => {
       if (val){
         this.assignedPartnerControl.setValidators([Validators.required]);
       } else  {
         this.assignedPartnerControl.setValidators([]);
         this.assignedPartnerControl.reset();
       }
    });

    combineLatest([this.companyControl.valueChanges, this.partnerControl.valueChanges, this.typeControl.valueChanges])
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      ).subscribe((val: [number, string, number]) => {
      this.parentContractControl.reset();
        if (val[1]) {
          this.partnerService.getPartnerContracts(val[1])
            .subscribe((contracts: ListResponse<Contract>) => {
              if (this.contractType?.key === CONTRACT_TYPE_FRANCHISE ||
                this.contractType?.key === CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS ||
                this.contractType?.key === CONTRACT_TYPE_FRANCHISE_AGREEMENT) {
                this.availableContracts = contracts.items.filter((contract: Contract) =>
                  contract.company?.id === val[0] &&
                  [CONTRACT_TYPE_PARTNERSHIP, CONTRACT_TYPE_MANDATE,
                    CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_MANDATE_STUDENT,
                    CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE].includes(contract.type?.key) &&
                  [
                    CONTRACT_STATUS_ACTIVE
                  ].includes(contract.status?.key)
                );
                this.parentContractControl.setValidators([Validators.required]);
                this.parentContractControl.updateValueAndValidity();
              } else if (this.contractType?.key === CONTRACT_TYPE_SELF_BILLING) {
                // this.getListOfVatButton = false;
                this.availableContracts = contracts.items.filter((contract: Contract) =>
                  contract.company?.id === val[0] &&
                  [CONTRACT_TYPE_PARTNERSHIP, CONTRACT_TYPE_MANDATE, CONTRACT_TYPE_PROFIT,
                    CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_MANDATE_STUDENT,
                    CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE].includes(contract.type?.key) &&
                  [
                    CONTRACT_STATUS_ACTIVE,
                    CONTRACT_STATUS_NEW,
                    CONTRACT_STATUS_SENT_WITH_AUTENTI
                  ].includes(contract.status?.key)
                );
              } else {
                this.availableContracts = contracts.items.filter((contract: Contract) =>
                  contract.company?.id === val[0] &&
                  [CONTRACT_TYPE_PARTNERSHIP, CONTRACT_TYPE_MANDATE, CONTRACT_TYPE_PROFIT,
                    CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_MANDATE_STUDENT,
                    CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE].includes(contract.type?.key) &&
                  ![
                    CONTRACT_STATUS_CLOSED,
                    CONTRACT_STATUS_CANCELED,
                    CONTRACT_STATUS_TERMINATED,
                    CONTRACT_STATUS_TO_TERMINATE,
                    CONTRACT_STATUS_DURING_TERMINATION
                  ].includes(contract.status?.key)
                );
              }
              this.contracts.next(this.availableContracts);
              if (this.availableContracts.length === 1) {
                this.parentContractControl.setValue(this.availableContracts[0].uuid);
              }
            });
        }
      });

    combineLatest([this.companyControl.valueChanges, this.ofwcaControl.valueChanges])
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      ).subscribe((val: [number, string]) => {
      this.parentContractControl.reset();
        if (val[1]) {
          this.ofwcaService.getOfwcaContracts(val[1])
            .subscribe((contracts: ListResponse<Contract>) => {
              const availableContracts = contracts.items.filter((contract: Contract) =>
                contract.company?.id === val[0] &&
                [CONTRACT_TYPE_PARTNERSHIP, CONTRACT_TYPE_MANDATE, CONTRACT_TYPE_PROFIT,
                  CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_MANDATE_STUDENT,
                  CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE].includes(contract.type?.key) &&
                ![
                  CONTRACT_STATUS_CLOSED,
                  CONTRACT_STATUS_CANCELED,
                  CONTRACT_STATUS_TERMINATED,
                  CONTRACT_STATUS_TO_TERMINATE,
                  CONTRACT_STATUS_DURING_TERMINATION
                ].includes(contract.status?.key)
              );
              this.contracts.next(availableContracts);
              if (availableContracts.length === 1) {
                this.parentContractControl.setValue(availableContracts[0].uuid);
              }
            });
        }
      });

    combineLatest([
      this.companyControl.valueChanges.pipe(startWith(this.companyControl.value)),
      this.typeControl.valueChanges.pipe(startWith(this.typeControl.value)),
      this.concludeDateControl.valueChanges.pipe(startWith(this.concludeDateControl.value)),
    ])
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        // this.setDefaultCommissionTable();
      });
    this.numberGenerateControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        startWith(true)
      ).subscribe(val => {
        if (val) {
          this.contractForm.get('number').setValue(null);
          this.contractForm.get('number').disable();
          this.required = false;
        } else {
          this.required = true;
          this.contractForm.get('number').enable();
        }
    });

    this.typeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            this.showPartnershipContractSelect = dictKey === CONTRACT_TYPE_TERMINAL;
            this.showPartnershipContractSelect = dictKey === CONTRACT_TYPE_TERMINAL;
          });
      });

    combineLatest([this.authService.getUserPermissions(), this.typeControl.valueChanges])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val) => {
        if (val[0].contract.write) {
          this.limitDates = false;
          return;
        }

        this.dictService.getKey(val[1])
          .subscribe((typeKey: string) => {
            this.limitDates = [CONTRACT_TYPE_MANDATE, CONTRACT_TYPE_PARTNERSHIP, CONTRACT_TYPE_PROFIT,
              CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_MANDATE_STUDENT,
              CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE].includes(typeKey);
          });
      });

    this.selfBillingVatPayerControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        startWith(false)
      ).subscribe((vatPayer: boolean) => {
        if (vatPayer) {
          this.selfBillingCheckoutMethodControl.enable();
        } else {
          this.selfBillingCheckoutMethodControl.setValue(false);
          this.selfBillingCheckoutMethodControl.disable();
        }
      });

    this.dictService.getDictSubject()
      .pipe(
        first(),
        map((dicts: Dictionary[]) => {
          return dicts.find((dict: Dictionary) => dict.type === DICT_TYPE_COMPANY && dict.key === COMPANY_ASF_PREMIUM);
        })
      ).subscribe((dict: Dictionary) => this.companyControl.setValue(dict.id));
  }

  contractTypeChanged(contractType: Dictionary): void {
    this.contractType = contractType;
    // this.updateCommissionTableRequirement();
    if (this.contractType?.key === CONTRACT_TYPE_FRANCHISE ||
      this.contractType?.key === CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS ||
      this.contractType?.key === CONTRACT_TYPE_FRANCHISE_AGREEMENT) {
      this.facilityControl.setValidators([Validators.required]);
      this.parentContractControl.reset();
      this.facilityControl.enable();
      this.facilityControl.reset();
    } else {
      this.parentContractControl.clearValidators();
      this.facilityControl.clearValidators();
      this.parentContractControl.reset();
      this.facilityControl.disable();
      this.facilityControl.reset();
    }

    if (this.contractType?.key === this.CONTRACT_TYPE_PARTNERSHIP ||
      this.contractType?.key === this.CONTRACT_TYPE_MANDATE ||
      this.contractType?.key === this.CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE ||
      this.contractType?.key === this.CONTRACT_TYPE_MANDATE_ONLY_HEALTH ||
      this.contractType?.key === CONTRACT_TYPE_MANDATE_STUDENT
    )
      {
        this.partnershipContractType = true;
      } else{
        this.partnershipContractType = false;
        this.customRatesForm.setValue(false);
      }

    if (this.PARTNERSHIP_ANNEX_TYPES.includes(this.contractType?.key))
    {
      this.customTermsContractType = true;
    } else {
      this.customTermsContractType = false;
      this.customTermsForm.setValue(false);
    }

    if (this.contractType?.key === this.CONTRACT_TYPE_DURING_REGISTRATION ||
      this.contractType?.key === this.CONTRACT_TYPE_MANDATE ||
      this.contractType?.key === this.CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE ||
      this.contractType?.key === this.CONTRACT_TYPE_MANDATE_ONLY_HEALTH ||
      this.contractType?.key === this.CONTRACT_TYPE_FOR_DEREGISTRATION ||
      this.contractType?.key === this.CONTRACT_TYPE_MANDATE_STUDENT ||
      this.contractType?.key === this.CONTRACT_TYPE_SELF_BILLING ||
      this.contractType?.key === this.CONTRACT_TYPE_PARTNERSHIP ||
      this.contractType?.key === CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE ||
      this.contractType?.key === CONTRACT_TYPE_LEAD_ONLY_HEALTH ||
      this.contractType?.key === CONTRACT_TYPE_LEAD
    )
    {
      if (this.contractType?.key === this.CONTRACT_TYPE_DURING_REGISTRATION ||
        this.contractType?.key === this.CONTRACT_TYPE_MANDATE ||
        this.contractType?.key === this.CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE ||
        this.contractType?.key === this.CONTRACT_TYPE_MANDATE_ONLY_HEALTH ||
        this.contractType?.key === this.CONTRACT_TYPE_MANDATE_STUDENT ||
        this.contractType?.key === this.CONTRACT_TYPE_FOR_DEREGISTRATION) {
         this.dictService.getId(FORM_OF_BUSINESS_NONE_PROPRIETORSHIP, DICT_TYPE_FORM_OF_BUSINESS)
          .subscribe((resultDictId: number) => {
            this.nonePartnershipTypeId = resultDictId;
            if(this.dialogRef === null) {
              this.partnerControl.reset();
            }
          });
      }
      this.nonePartnershipContractType = true;
    } else{
      this.nonePartnershipContractType = false;
    }
    if (this.contractType?.key === this.CONTRACT_TYPE_SELF_BILLING) {
      this.parentContractControl.setValidators([Validators.required]);
      this.parentContractControl.updateValueAndValidity();
      this.selfBillingEmailControl.enable();
      this.selfBillingPhoneControl.enable();
      this.selfBillingAccountNumberControl.enable();
      this.concludeDateControl.setValidators([Validators.required]);
      this.selfBillingContractType = true;
    } else if (this.contractType?.key === CONTRACT_TYPE_PARTNERSHIP || this.contractType?.key === CONTRACT_TYPE_PROFIT) {
      this.parentContractControl.updateValueAndValidity();
      this.selfBillingEmailControl.enable();
      this.selfBillingPhoneControl.enable();
      this.selfBillingAccountNumberControl.enable();
      this.concludeDateControl.setValidators([Validators.required]);
    } else {
      this.selfBillingEmailControl.disable();
      this.selfBillingPhoneControl.disable();
      this.selfBillingAccountNumberControl.disable();
      this.concludeDateControl.setValidators([Validators.required]);
      this.parentContractControl.clearValidators();
      this.selfBillingContractType = false;
    }
    this.contractForm.updateValueAndValidity();
    this.parentContractControl.updateValueAndValidity();
  }

  partnerChanged(partner: Partner): void {
    if (partner) {
      const emails = partner.billingEmails?.length ? partner.billingEmails : (partner.mainEmails ?? []);
      const email = emails.find((item: EmailAddress) => !!item?.address);
      this.selfBillingEmailControl.setValue(email?.address ?? '');

      const phones = partner.billingPhones?.length ? partner.billingPhones : (partner.primaryPhones ?? []);
      const phone = phones.find((item: PhoneNumber) => !!item?.number);

      if (partner.billingPhones.length > 0) {
        partner.billingPhones.forEach((phone: PhoneNumber) => {
          this.selfBillingPhoneControl.setValue(phone.number);
        });
      } else {
        // partner.phones.forEach((phone: PhoneNumber) => {
        //   this.selfBillingPhoneControl.setValue(phone.number);
        // });
        partner.phones
          .filter((phone: PhoneNumber) => phone.main === true)
          .forEach((phone: PhoneNumber) => {
            this.selfBillingPhoneControl.setValue(phone.number);
          });
      }
      this.selfBillingAccountNumberControl.setValue(partner.accountNumber);
      // this.selfBillingVatPayerControl.setValue(partner.vatPayer);
      // this.selfBillingActiveVatPayerControl.setValue(partner.activeVatPayer);
      this.selfBillingCheckoutMethodControl.setValue(partner.checkoutMethod);
      this.partnerNip = partner.nip;
    }
  }

  ngAfterViewInit(): void {
    if (this.partnerObject) {
      this.partnerChanged(this.partnerObject);
      this.dictService.getDictSubject()
        .pipe(
          first(),
          map((dicts: Dictionary[]) => {
            return dicts.find((dict: Dictionary) => dict.type === DICT_TYPE_CONTRACT_OWNER && dict.key === CONTRACT_OWNER_PARTNER);
          }),
          tap(() => this.partnerControl.setValue(this.partnerObject.uuid)),
          delay(0),
          tap((dict: Dictionary) => this.ownerControl.setValue(dict.id))
        ).subscribe();
    }

    if (this.ofwcaObject) {
      this.dictService.getDictSubject()
        .pipe(
          first(),
          map((dicts: Dictionary[]) => {
            return dicts.find((dict: Dictionary) => dict.type === DICT_TYPE_CONTRACT_OWNER && dict.key === CONTRACT_OWNER_OFWCA);
          }),
          tap(() => this.ofwcaControl.setValue(this.ofwcaObject.uuid)),
          delay(0),
          tap((dict: Dictionary) => this.ownerControl.setValue(dict.id))
        ).subscribe();
    }


    if (this.selfBillingFormObject) {
      this.dictService.getDictSubject()
        .pipe(
          first(),
          map((dicts: Dictionary[]) => {
            return dicts.find((dict: Dictionary) => dict.type === DICT_TYPE_CONTRACT_OWNER && dict.key === CONTRACT_OWNER_PARTNER);
          }),
          tap(() => this.partnerControl.setValue(this.selfBillingFormObject.partner.uuid)),
          delay(0),
          tap((dict: Dictionary) => this.ownerControl.setValue(dict.id))
        ).subscribe();
      this.companyControl.setValue(this.selfBillingFormObject.company.id);
      this.selfBillingAccountNumberControl.setValue(this.selfBillingFormObject.accountNumber);
      this.selfBillingPhoneControl.setValue(this.selfBillingFormObject.phone);
      this.selfBillingEmailControl.setValue(this.selfBillingFormObject.email);
      this.partnerNip = this.selfBillingFormObject.nip;
      this.concludeDateControl.setValue(moment());
      this.selfBillingFormControl.setValue(this.selfBillingFormObject.id);
      this.dictService.get(CONTRACT_TYPE_SELF_BILLING, DICT_TYPE_CONTRACT_TYPE)
        .subscribe((dict: Dictionary) => {
         this. contractTypeChanged(dict);
          this.typeControl.setValue(dict.id);
        });
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  requireOfwca(): void {
    this.ofwcaControl.setValidators([Validators.required]);
    this.partnerControl.setValidators([]);
    this.ofwcaControl.enable();
    this.partnerControl.disable();
    this.partnerControl.reset();
    this.requiredOfwca = true;
    this.requiredPartner = false;
  }

  requirePartner(): void {
    this.partnerControl.setValidators([Validators.required]);
    this.ofwcaControl.setValidators([]);
    this.partnerControl.enable();
    this.ofwcaControl.disable();
    this.ofwcaControl.reset();
    // this.requiredOfwca = false;
    // this.requiredPartner = true;
  }

  sendForm(): void {
    if (!this.contractForm.valid) {
      this.contractForm.markAllAsTouched();

      Object.keys(this.contractForm.controls).forEach(field => {
        const control = this.contractForm.get(field);

        if (control && control.invalid) {
          console.error('Niepoprawne pole:', {
            field,
            value: control.value,
            errors: control.errors,
            status: control.status
          });
        }
      });

      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });

      return;
    }
    // if (this.selfBillingActiveVatPayerControl.value  && this.contractType?.key !== CONTRACT_TYPE_PARTNERSHIP){
    //   if (!this.vatTaxpayersAccountNumber.includes(this.selfBillingAccountNumberControl.value.substr(2).replace(/ /g, ""))){
    //     this.selfBillingAccountNumberControl.setErrors({vatPayerControl: true});
    //     this.snack.open('Numer rachunku bankowego jest inny niż w rejestrze płatników VAT', '', {
    //       duration: 2000,
    //     });
    //     return;
    //   }
    // }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.contractForm, this.formErrors);
    this.formErrors = {};

    this.contractService.sendForm(this.contractForm.getRawValue(), null)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Pomyślnie utworzono obiekt umowy', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (this.dialogRef) {
          this.contractCreated.emit(response.uuid);
          this.contractService.get(response.uuid)
            .subscribe((contract: Contract) => {
              this.dictService.getId(COMPANY_ASF, DICT_TYPE_COMPANY)
                .subscribe((dictId: number) => {
                  if (!this.PARTNERSHIP_ANNEX_TYPES.includes(contract.type.key) ||
                    (this.contractType.key === CONTRACT_TYPE_PARTNERSHIP && this.companyControl.value === dictId)) {
                    return;
                  }

                  const dialogRef = this.dialog.open(ContractInsuranceCompaniesAddDialogComponent, {
                    width: '90vw',
                    maxHeight: '90vh',
                    data: {
                      contractObject: contract,
                    },
                    autoFocus: false,
                  });

                  dialogRef.afterClosed().subscribe(result => {
                  });
                });
            });
        } else {
          this.router.navigate(['/umowy/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        if (error.error.error.list.partner) {
          this.snack.open(error.error.error.list.partner.toString() , error.status.toString(), {
            duration: 8000,
            panelClass: ['success-snackbar']
          });
        } else {
          this.snack.open( 'Podczas tworzenia obiektu umowy wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.contractForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (!this.dialogRef) {
      this.router.navigate(['/umowy']);
    } else {
      this.dialogRef.close();
    }
  }

  weekendsDatesFilter = (d): boolean => {
    if (!d) {
      return false;
    }

    const day = d.day();

    /* Prevent Saturday and Sunday for select. */
    return day !== 0 && day !== 6 ;
  };

  // getListOfVat(): void {
  //   this.getListOfVatButton = false;
  //   this.snack.open('Pobieranie danych z wykazu podatników VAT');
  //   this.contractService.listOfVatInformation(this.partnerNip )
  //     .subscribe((e: VatTaxpayers) => {
  //       this.snack.open('Pobrano dane z wykazu podatników VAT','' , {duration: 2000});
  //       this.contractForm.get('selfBillingVatPayer').setValue(e.vatPayer);
  //       this.contractForm.get('selfBillingActiveVatPayer').setValue(e.activeVatPayer);
  //       this.vatTaxpayersAccountNumber = e.accountNumbers;
  //       this.getListOfVatButton = true;
  //     }, (error: HttpErrorResponse) => {
  //       this.snack.open('Nie udało się pobrać danych z  wykazu podatników VAT', error.status.toString(), {
  //         duration: 2000
  //       });
  //     });
  //   this.selfBillingVatPayerControl.disable();
  //   this.selfBillingActiveVatPayerControl.disable();
  //
  // }
  copyMessage(val: string): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka', '', {duration: 2000});

  }


  private updateCommissionTableRequirement(): void {
    this.commissionTableRequired =
      COMMISSION_STATEMENT_GENERATION_CRITERIA_TYPE
        .includes(
          this.contractType?.key
        );

    if (this.commissionTableRequired) {
      this.commissionTableControl.setValidators([
        Validators.required
      ]);
    } else {
      this.commissionTableControl.clearValidators();

      this.commissionTableControl.setValue(null,
        {
          emitEvent: false
        }
      );
    }

    this.commissionTableControl.updateValueAndValidity({
      emitEvent: false
    });
  }

  private setDefaultCommissionTable(): void {
    if (!this.commissionTableRequired) {
      return;
    }
    this.commissionTableControl.setValue(null, {emitEvent: false});
    const companyId: number = this.companyControl.value;
    const contractTypeId: number = this.typeControl.value;

    if (!companyId || !contractTypeId || !this.commissionTables.length ) {
      return;
    }

    /*
     * Najpierw szukamy wyłącznie tabel przypisanych
     * do Firma + Rodzaj umowy.
     */
    const matchingTables =
      this.commissionTables
        .filter((table: CommissionTableListItem) => (table.assignments || []).some(assignment => Number(assignment.companyId) === Number(companyId) && Number(assignment.contractTypeId) === Number(contractTypeId)))
        .sort((a: CommissionTableListItem, b: CommissionTableListItem) => (b.validFrom || '').localeCompare(a.validFrom || ''));

    if (!matchingTables.length) {
      return;
    }
    const concludeDate = this.concludeDateControl.value;
    /*
     * Jeśli nie ma jeszcze daty zawarcia,
     * wybieramy ostatnią tabelę przypisaną
     * do Firma + Rodzaj umowy.
     */
    if (!concludeDate) {this.commissionTableControl.setValue(matchingTables[0].uuid);
      return;
    }

    const date =  moment(concludeDate).format('YYYY-MM-DD');
    const commissionTable = matchingTables.find((table: CommissionTableListItem) => table.validFrom <= date && (!table.validTo || table.validTo >= date));
    this.commissionTableControl.setValue(commissionTable?.uuid ?? null);
  }
}
